<div id="comparatoreMFFooter" class="footer-container">

  <!-- <div class="row">
    <div class="col-4 privacy-link-container">
      <a routerLink="/informative/privacy"><span>Informativa privacy</span></a>
    </div>
    <div class="col-4 privacy-link-container">
      <a routerLink="/informative/cookies/edit">Impostazioni cookie</a>
    </div>
    <div class="col-4 privacy-link-container">
      <a href="https://www.milanofinanza.it/informative/informativa-cookie"><span>Informativa cookie</span></a>
    </div>
  </div> -->

  <!-- <div class="row">

    <div class="col-12 footer-content">
      <div>
        <p class="footer-content-p">
          Milano Finanza Interattivo © Milano Finanza 2023 Partita IVA 08931350154 <br />
          Responsabile della Protezione dei dati personali - Milano Finanza Editori S.p.A. - via M. Burigozzo 5 - 20122, Milano, email: <a class="block_copyright" href="mailto:dpo@class.it">dpo&#64;class.it</a>
        </p>
      </div>
    </div>

  </div> -->

</div>